/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum RtxReportId {
    RtVueFourteenDay = '018f7d9f-aa17-7d3c-8d61-1c255e9cac59',
}